import { css } from '../../styles/theme';

export const StylesOV_GB = css``;
